module.exports = __webpack_public_path__ + "static/media/logo_dsc.104c777f.png";